module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['item', _vm.itemWidth(_vm.item), _vm.itemHeight(_vm.item), _vm.isItemDisabled() ? 'is-disabled' : '']
  }, [(_vm.item.type === 'collection') ? _c('div', {
    class: ['item__note', 'item__note--' + _vm.item.position]
  }, [_c('span', [_vm._v(_vm._s(_vm.item.story))])]) : _vm._e(), _vm._v(" "), (_vm.item.image) ? _c('figure', {
    on: {
      "click": function($event) {
        _vm.showModal(_vm.index)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.imagePath
    }
  })]) : _vm._e(), _vm._v(" "), _c('modal', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    attrs: {
      "item": _vm.item
    },
    on: {
      "hide": function($event) {
        _vm.hideModal()
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-195ecf5b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Item.vue
// module id = 313
// module chunks = 0